module.exports = __webpack_public_path__ + "static/media/1.6053aef3.jpg";